import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { nextLessonSelector } from '@store/session';

const useIntroLoCompleted = () => {
    const { hideIntroLoOnStudentExperience } = useFlags();
    const nextLesson = useSelector(nextLessonSelector);

    return hideIntroLoOnStudentExperience || Boolean(!nextLesson?.intro);
};

export default useIntroLoCompleted;
